export const chatBubbleStyles = `
/* Catchy avatar next to incoming bubbles (WhatsApp style, bottom-aligned) */
.qbz-ava {
  width: 26px;
  height: 26px;
  flex-shrink: 0;
  align-self: flex-end;
  margin-right: 6px;
  margin-bottom: 2px;
  border-radius: 50%;
  border: 1px solid var(--catchup-blue-100);
  object-fit: cover;
  object-position: center;
  box-shadow: 0 1px 4px -1px rgba(15,72,89,0.25);
}

.qbz-welcome-row {
  display: flex;
  justify-content: flex-start;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.qbz-welcome-bubble {
  color: var(--catchup-gray-700);
  border-radius: 16px;
  border-top-left-radius: 4px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.qbz-welcome-text {
  font-size: var(--fs-lg);
  line-height: 1.625;
}

/* Start affordance under the welcome bubble — indented to sit beneath the
   bubble (past the avatar), so it reads as the next step after Catchy's hello. */
.qbz-start-row {
  display: flex;
  justify-content: flex-start;
  padding-left: 2rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.5rem;
}

.qbz-msg-row {
  display: flex;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.qbz-justify-start {
  justify-content: flex-start;
}

.qbz-justify-end {
  justify-content: flex-end;
}

.qbz-msg-bubble {
  border-radius: 16px;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  overflow: hidden;
}

.qbz-msg-assistant {
  color: var(--catchup-gray-700);
  border-top-left-radius: 4px;
}

.qbz-msg-user {
  color: var(--catchup-white);
  border-top-right-radius: 4px;
}

.qbz-msg-inner {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.qbz-image-wrap {
  flex-shrink: 0;
  overflow: hidden;
  padding-right: 0.75rem;
  position: relative;
}

.qbz-image {
  width: 100%;
  height: auto;
  border-radius: var(--rad-catchup-small);
}

.qbz-text-block {
  font-size: var(--fs-lg);
  line-height: 1.625;
  user-select: text;
}

.qbz-text-flex-1 {
  flex: 1 1 0%;
}

.qbz-audio-para {
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  border-radius: var(--rad-catchup-small);
}

.qbz-audio-active {
  font-weight: 600;
}

.qbz-audio-played {
  opacity: 0.7;
}

.qbz-audio-pending {
  opacity: 0.4;
}

.qbz-audio-para-inner {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5rem;
}

.qbz-audio-para-text {
  flex: 1 1 0%;
}

.qbz-streaming-row {
  display: flex;
  justify-content: flex-start;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.qbz-streaming-bubble {
  border-radius: var(--rad-catchup-large);
  border-top-left-radius: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.qbz-cursor {
  display: inline-block;
  width: 0.125rem;
  height: 1rem;
  background-color: var(--catchup-blue-600);
  vertical-align: middle;
}

.qbz-speed-selector {
  position: absolute;
  z-index: 20;
  bottom: 100%;
  margin-bottom: 0.25rem;
  right: 0;
  border-radius: var(--rad-catchup-medium);
  padding: 0.5rem;
}

.qbz-speed-title {
  font-size: var(--fs-sm);
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--catchup-blue-800);
}

.qbz-speed-list {
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.qbz-speed-option {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  border-radius: var(--rad-catchup-small);
  font-size: var(--fs-sm);
}

.qbz-speed-option-active {
  background-color: var(--catchup-blue-600);
  color: var(--catchup-white);
  font-weight: 600;
}

.qbz-speed-option-inactive {
  color: var(--catchup-blue-800);
}

.qbz-speed-option-inactive:hover {
  background-color: var(--catchup-blue-50);
}

.qbz-root-full {
  height: 100%;
}

.qbz-root-absolute {
  position: absolute;
}

.qbz-card {
  border-radius: var(--rad-catchup-2xlarge);
  box-shadow: var(--shadow-input);
  background-color: var(--catchup-white);
}

/* chatTransparent: the host card owns the surface — no white card of our own */
.qbz-card--bare {
  background-color: transparent;
  box-shadow: none;
}
.qbz-card--bare .qbz-header {
  background-color: transparent;
}

.qbz-card-inner {
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 0.5rem;
}

.qbz-header {
  position: relative;
  text-align: center;
  background-color: var(--catchup-white);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 0.5rem;
  border-top-left-radius: var(--rad-catchup-2xlarge);
  border-top-right-radius: var(--rad-catchup-2xlarge);
}

.qbz-header-left {
  position: absolute;
  left: 1rem;
}

.qbz-header-right {
  position: absolute;
  right: 1rem;
}

.qbz-row {
  display: flex;
  flex-direction: row;
}

.qbz-title {
  font-weight: 700;
  font-size: var(--fs-lg);
  max-width: 50%;
  margin-left: auto;
  margin-right: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: var(--catchup-blue-800);
}

.qbz-text-body {
  min-height: 0;
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  position: relative;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
}

.qbz-image-preview-wrap {
  position: absolute;
  bottom: 3rem;
  left: 0.5rem;
  z-index: 0;
}

.qbz-image-preview-rel {
  position: relative;
}

.qbz-image-preview {
  height: 5rem;
  box-shadow: var(--shadow-card);
  border-radius: var(--rad-catchup-xlarge);
}

.qbz-image-remove {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  z-index: 10;
}

.qbz-image-remove-icon {
  width: 1rem;
  height: 1rem;
}

.qbz-scroll {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  border-radius: var(--rad-catchup-large);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.qbz-scroll-inner {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  row-gap: 0.25rem;
}

.qbz-overlay {
  position: absolute;
  bottom: 3.5rem;
  left: 50%;
  transform: translateX(-50%);
}

.qbz-error-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: var(--catchup-red);
  border-radius: var(--rad-catchup-large);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  column-gap: 0.5rem;
}

.qbz-error-text {
  flex: 1 1 0%;
}

.qbz-continue-box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: var(--rad-catchup-large);
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  column-gap: 0.5rem;
  color: var(--catchup-gray-700);
}

.qbz-continue-text {
  flex: 1 1 0%;
}

.qbz-action-box {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  border-radius: var(--rad-catchup-large);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  gap: 0.5rem;
  color: var(--catchup-gray-700);
}

.qbz-action-button {
  border-width: 1px;
  border-style: solid;
  border-color: var(--catchup-blue-500);
  background-color: var(--catchup-blue-500);
  color: var(--catchup-white);
  border-radius: var(--rad-catchup-button);
  transition: all 300ms cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  max-width: 100%;
  text-align: left;
  font-size: var(--fs-sm);
  line-height: 1.375;
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.qbz-action-button:hover {
  background-color: var(--catchup-blue-700);
}

.qbz-action-button:active {
  background-color: var(--catchup-blue-500);
}

.qbz-input-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.25rem;
}

.qbz-draw-toggle {
  transition: all 500ms cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.qbz-draw-toggle-visible {
  opacity: 1;
  max-width: 40px;
  margin-right: 0;
}

.qbz-draw-toggle-hidden {
  opacity: 0;
  max-width: 0;
  margin-right: 0;
  pointer-events: none;
}

.qbz-input-wrap {
  transition: all 500ms cubic-bezier(0.4, 0, 0.2, 1);
  flex: 1 1 0%;
}

.qbz-input-wrap-mr {
  margin-right: 0.5rem;
}

.qbz-input-wrap-ml {
  margin-left: 0.5rem;
}

.qbz-send-toggle {
  transition: all 500ms cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.qbz-send-toggle-visible {
  opacity: 1;
  max-width: 40px;
  margin-right: 0;
}

.qbz-send-toggle-hidden {
  opacity: 0;
  max-width: 0;
  margin-right: 0;
  pointer-events: none;
}

.qbz-audio-body {
  flex: 1 1 0%;
  display: flex;
  flex-direction: column;
  min-height: 0;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-bottom: 1rem;
  overflow: visible;
}

.qbz-audio-scroll {
  flex: 1 1 0%;
  overflow-y: auto;
  border-radius: var(--rad-catchup-large);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-bottom: 0.5rem;
}

.qbz-audio-controls {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.qbz-audio-toolbar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  column-gap: 0.75rem;
}

.qbz-audio-tool {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.25rem;
}

.qbz-device-popover {
  position: absolute;
  z-index: 20;
  bottom: 100%;
  margin-bottom: 0.25rem;
  left: 50%;
  transform: translateX(-50%);
}

.qbz-speed-pill {
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: var(--catchup-blue-600);
  color: var(--catchup-white);
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  border-radius: var(--rad-catchup-large);
}

.qbz-speed-pill-text {
  font-size: var(--fs-md);
  font-weight: 600;
}

.qbz-status-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.25rem;
}

.qbz-status-text-blue {
  font-size: var(--fs-base);
  font-weight: 600;
  color: var(--catchup-blue-700);
}

.qbz-status-text-red {
  font-size: var(--fs-base);
  font-weight: 600;
  color: var(--catchup-red);
}

.qbz-hold {
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 0.25rem;
  user-select: none;
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
}

.qbz-hold-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.qbz-hold-enabled {
  cursor: pointer;
}

.qbz-hold-enabled:active {
  transform: scale(0.95);
}

.qbz-hidden {
  display: none;
}
`;
